const modifiedFields = ['evenPolicyItems', 'notificationsModel'];
const modifiedFieldCustom = {
  evenPolicyItems: ['metricKey', 'productResourceId'],
  notificationsModel: ['recipientKey', 'recipientName', 'notificationMethods', 'recipientType']
};
const sortByFields = {
  evenPolicyItems: ['eventPolicyId'],
  notificationsModel: ['recipientName'],
  orderBy: ['asc']
};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
